import React from 'react';

import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';
import LanguageChangeSync from 'src/components/LanguageChangeSync';
import { StepContextProvider } from 'src/contexts/stepContext/stepContextProvider';
import useMicrowebStore from 'src/hooks/useMicrowebStore';
import { HasFetchedProvider } from 'src/root/FetchSkjemaContext';

import type { MicrowebSliceState } from '../store/reducers/microwebSlice';

import MicrowebRoot from '@helsenorge/framework-utils/components/microweb-root';

import SkjemaContainer from '../components';
import { type MicrowebContainerStyle, sanitizeContainerStyle } from './containerStyle';

/** Propsene <hn-webcomp-skjema> leser. Alle kommer inn som HTML-attributter. */
export interface MicrowebSkjemaProps {
  skjemanavn?: string;
  /** Lastes et lagret skjemasvar i stedet for en ny skjemadefinisjon. */
  dokumentguid?: string;
  /** JSON-streng med forhandsutfylte data, brukes av generateQuestionnaireResponseData. */
  skjemadata?: string;
  /** Skjuler tilbake-knappen nar skjemaet vises som stegvisning. */
  hidebackbutton?: string;
  showpromptloginmessageinmicroweb?: boolean;
  showtopmessageinmicroweb?: boolean;
  showformtitle?: boolean;
  showsidebar?: boolean;
  shownavigator?: boolean;
  showstepperinmicroweb?: boolean;
  showvalidationsummary?: boolean;
  showsubmitbutton?: boolean;
  showsavebutton?: boolean;
  showcancelbutton?: boolean;
  containerstyle?: MicrowebContainerStyle;
}

export const MicrowebSkjemaContents: React.FC<MicrowebSkjemaProps> = ({
  skjemanavn,
  dokumentguid,
  skjemadata,
  hidebackbutton,
  showpromptloginmessageinmicroweb,
  showtopmessageinmicroweb,
  showformtitle,
  showsidebar,
  shownavigator,
  showstepperinmicroweb,
  showvalidationsummary,
  showsubmitbutton,
  showsavebutton,
  showcancelbutton,
  containerstyle,
}) => {
  const microwebState: Partial<MicrowebSliceState> = {
    isMicroweb: true,
    skjemaTekniskNavn: skjemanavn,
    documentGuid: dokumentguid,
    skjemadata: skjemadata,
    hidebackbutton: hidebackbutton,
    showPromptLoginMessageInMicroweb: showpromptloginmessageinmicroweb,
    showTopMessageInMicroweb: showtopmessageinmicroweb,
    showFormTitle: showformtitle,
    showSidebar: showsidebar,
    showNavigator: shownavigator,
    showStepperInMicroweb: showstepperinmicroweb,
    showValidationSummary: showvalidationsummary,
    showSubmitButton: showsubmitbutton,
    showSaveButton: showsavebutton,
    showCancelButton: showcancelbutton,
  };

  const reduxStore = useMicrowebStore(microwebState);

  return (
    <div className="hn-webcomp-skjema__container" style={sanitizeContainerStyle(containerstyle)}>
      <Provider store={reduxStore}>
        <MicrowebRoot>
          <BrowserRouter>
            <HasFetchedProvider>
              <StepContextProvider>
                <LanguageChangeSync />
                <SkjemaContainer />
              </StepContextProvider>
            </HasFetchedProvider>
          </BrowserRouter>
        </MicrowebRoot>
      </Provider>
    </div>
  );
};
